import React from "react";
import { useDispatch } from "react-redux";
import Axios from "axios";
import { cargarNotaria } from "../../actions/notariaAction";
import CotizadorCore from "../../components/Cotizador/CotizadorCore.js";

const Cotizador = () => {
  const dispatch = useDispatch();
  const [servicios, setServicios] = React.useState([]);

  React.useEffect(() => {
    const consultar = async () => {
      let config = {
        method: "GET",
        mode: "cors",
        headers: {
          "Access-Control-Allow-Origin": true,
          Authorization: "Bearer " + process.env.REACT_APP_TOKEN_API,
        },
      };

      const resultado = await Axios.get(
        process.env.REACT_APP_UrlApi + "notaria",
        config
      );
      if (resultado.status === 200) {
        let dataTemp = {};
        resultado.data.forEach((element) => {
          dataTemp[element.variable] = element.value;
        });
        dispatch(cargarNotaria(dataTemp));
      }
    };
    consultar();
  }, []);

  React.useEffect(() => {
    const consultarServicios = async () => {
      let config = {
        method: "GET",
        mode: "cors",
        headers: {
          "Access-Control-Allow-Origin": true,
          Authorization: "Bearer " + process.env.REACT_APP_TOKEN_API,
        },
      };
      const resultado = await Axios.get(
        process.env.REACT_APP_UrlApi + "configCotizador",
        config
      );
      setServicios(resultado.data);
    };
    consultarServicios();
  }, []);

  const onCotizar = (payload) =>
    Axios.post(
      process.env.REACT_APP_UrlApi + "cotizador/cotizar",
      payload,
      {
        headers: {
          Authorization: "Bearer " + process.env.REACT_APP_TOKEN_API,
        },
      }
    );

  return <CotizadorCore onCotizar={onCotizar} serviciosIniciales={servicios} />;
};

export default Cotizador;